import { Directive } from '@angular/core';

@Directive({
    selector: '[appTitle],app-title',
    host: {
        class: 'app-title'
    },
    standalone: false
})
export class TitleDirective {

  constructor() { }

}
